import { graphql } from '@apollo/react-hoc';
import OportunidadeStatusQueryGql from './OportunidadeStatusQueryGql.graphql';

export const OportunidadeStatusQuery = graphql(OportunidadeStatusQueryGql, {
  name: 'oportunidadeStatus',
  options: ({ match }) => ({
    variables: { id: match.params.idOportunidade },
  }),
});
